import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import "../Styles/Header.css";
import { useSelector } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

/*
  MENU CONFIG
  - idx   : the same activeIndex values you used before (0,1,2,3,4,17,5,15,32,6,7,8,70,9,11)
  - id    : the id checked by findMenu(id)
  - sub   : the id checked by findSubMenu(sub)
  - orMenu: (only Service request items) keeps the old  findSubMenu(24) || findMenu(9)  logic
*/
const MENUS = [
  {
    idx: 0,
    id: 2,
    label: "User Manage",
    icon: "fa-users",
    items: [
      { sub: 1, to: "/user", label: "User", icon: "fa-user" },
      { sub: 4, to: "/patient", label: "Patient", icon: "fa-heartbeat" },
      { sub: 2, to: "/agent", label: "Agent", icon: "fa-user-secret" },
      { sub: 3, to: "/doctor", label: "Doctor", icon: "fa-user-md" },
       { sub: 6, to: "/shop-owner", label: "Chamber(doctor's chambers)", icon: "fa-home" },   
      { sub: 3, to: "/hospital", label: "Hospital", icon: "fa-hospital-o" },
      { sub: 3, to: "/diagnostic-center", label: "Diagnostic Center", icon: "fa-flask" },
      { sub: 7, to: "/senior-marketing-executive", label: "Senior Marketing Executive", icon: "fa-user" },
      { sub: 5, to: "/store-owner", label: "Store Owner", icon: "fa-shopping-bag" },
 
      { sub: 7, to: "/vendor", label: "Vendor", icon: "fa-handshake-o" },
    ],
  },
  {
    idx: 1,
    id: 3,
    label: "Product Manage",
    icon: "fa-cubes",
    items: [
      { sub: 8, to: "/category", label: "Category", icon: "fa-th-large" },
      { sub: 9, to: "/sub-category", label: "Subcategory", icon: "fa-sitemap" },
      { sub: 10, to: "/product", label: "Product", icon: "fa-cube" },
      { sub: 11, to: "/service", label: "Service", icon: "fa-cogs" },
      { sub: 11, to: "/audiometer", label: "Audiometer", icon: "fa-headphones" },
    ],
  },
  {
    idx: 2,
    id: 4,
    label: "Employee Manage",
    icon: "fa-id-badge",
    items: [
      { sub: 13, to: "/employee", label: "Employee List", icon: "fa-list" },
      { sub: 12, to: "/employee-role", label: "Employee Role", icon: "fa-id-card-o" },
      { sub: 12, to: "/employee-tracking", label: "Employee Tracking", icon: "fa-map-marker" },
    ],
  },
  {
    idx: 3,
    id: 5,
    label: "Purchase Bill Manage",
    icon: "fa-file-text-o",
    items: [
      { sub: 14, to: "/Purchase-bill-list", label: "Purchase Bill List", icon: "fa-list-alt" },
      { sub: 15, to: "/Purchase-bill", label: "Purchase Bill Add", icon: "fa-plus-circle" },
    ],
  },
  {
    idx: 4,
    id: 6,
    label: "Sell Bill Manage",
    icon: "fa-shopping-cart",
    items: [
      { sub: 16, to: "/Sell-bill", label: "Sell Bill Add", icon: "fa-plus-circle" },
      { sub: 17, to: "/Sell-bill-list", label: "Sell Bill List", icon: "fa-list-alt" },
    ],
  },
  {
    idx: 17,
    id: 7,
    label: "Courier Service Manage",
    icon: "fa-truck",
    items: [
      { sub: 18, to: "/courier-add", label: "Add Courier Service", icon: "fa-plus-circle" },
      { sub: 19, to: "/courier-list", label: "Courier Service List", icon: "fa-list-ul" },
    ],
  },
  {
    idx: 5,
    id: 8,
    label: "Product Order Manage",
    icon: "fa-clipboard",
    items: [
      { sub: 20, to: "/customized-booking-create", label: "Online Customized booking ", icon: "fa-calendar-check-o" },
      { sub: 20, to: "/confirm-checkout", label: "Confirm user order", icon: "fa-check-circle" },
      { sub: 21, to: "/order-add-serial-number", label: "Add serial number", icon: "fa-barcode" },
      { sub: 21, to: "/reffer-patient", label: "Reffer patient orders", icon: "fa-share-alt" },
      { sub: 21, to: "/testbooking", label: "Test Booking Orders", icon: "fa-stethoscope" },
      { sub: 22, to: "/confirm-store-checkout", label: "Store order manage", icon: "fa-building-o" },
    ],
  },
  {
    idx: 15,
    id: 9,
    label: "Service request manage",
    icon: "fa-wrench",
    items: [
      { sub: 24, orMenu: 9, to: "/assign-service-person", label: "Assign service person", icon: "fa-user-plus" },
      { sub: 24, orMenu: 9, to: "/service-request-notification-list", label: "Service Reminder", icon: "fa-bell" },
    ],
  },
  {
    idx: 32,
    id: 11,
    label: "Store Wallet",
    icon: "fa-credit-card",
    items: [
      { sub: 27, to: "/store-wallet-balance", label: "View store wallet", icon: "fa-eye" },
    ],
  },
  {
    idx: 6,
    id: 10,
    label: "Report",
    icon: "fa-bar-chart",
    items: [
      { sub: 25, to: "/purchase-report", label: "Purchase Report", icon: "fa-download" },
      { sub: 26, to: "/sell-report", label: "Sell Report", icon: "fa-line-chart" },
      { sub: 26, to: "/income-report", label: "Income report", icon: "fa-arrow-circle-down" },
      { sub: 26, to: "/stock-report", label: "Stock Report", icon: "fa-archive" },
      { sub: 26, to: "/gst-purchase-report", label: "GST Purchase Report", icon: "fa-percent" },
      { sub: 26, to: "/gst-sell-report", label: "GST Sell Report", icon: "fa-pie-chart" },
      { sub: 26, to: "/expenditure-report", label: "Expenditure Report", icon: "fa-arrow-circle-up" },
      { sub: 26, to: "/profit-loss-report", label: "Profit  & Loss  Report", icon: "fa-balance-scale" },
      { sub: 26, to: "/salary-report", label: "Salary Report", icon: "fa-money" },
    ],
  },
  {
    idx: 7,
    id: 11,
    label: "Team",
    icon: "fa-sitemap",
    items: [{ sub: 27, to: "/create-team", label: "Team Create", icon: "fa-users" }],
  },
  {
    idx: 8,
    id: 12,
    label: "Work",
    icon: "fa-tasks",
    items: [
      { sub: 28, to: "/work-assign", label: "Work Assign to ME", icon: "fa-user-circle" },
      { sub: 29, to: "/work-assign-employee", label: "Work Assign to Employee", icon: "fa-user-plus" },
    ],
  },
  {
    idx: 70,
    id: 13,
    label: "DA Manage",
    icon: "fa-inr",
    items: [
      { sub: 30, to: "/da-list", label: "DA List", icon: "fa-list" },
      { sub: 31, to: "/employee-da", label: "Employeewise List", icon: "fa-user-circle-o" },
    ],
  },
  {
    idx: 9,
    id: 14,
    label: "Review",
    icon: "fa-star",
    items: [{ sub: 32, to: "/review-question", label: "Review Question", icon: "fa-question-circle" }],
  },
  {
    idx: 11,
    id: 15,
    label: "Doctor Payment",
    icon: "fa-money",
    items: [{ sub: 32, to: "/doctor-payment", label: "Payment List", icon: "fa-credit-card" }],
  },
];

const Header = () => {
  const [roleUser, setRole] = useState(localStorage.getItem("role") || null);
  const roleFromRedux = useSelector((state) => state.user.role);
  const [userDropdown, setUserDropdown] = useState(false);
  const [productDropdown, setProductDropdown] = useState(false);
  const [employeeDropdown, setEmployeeDropdown] = useState(false);
  const [purchaseDropdown, setPurchaseDropdown] = useState(false);
  const [sellDropdown, setSellDropdown] = useState(false);
  const [reportDropdown, setReportDropdown] = useState(false);

  const userDropdownRef = useRef(null);
  const productDropdownRef = useRef(null);
  const employeeDropdownRef = useRef(null);
  const purchaseDropdownRef = useRef(null);
  const sellDropdownRef = useRef(null);
  const reportRef = useRef(null);
  const dropdownRef = useRef(null);

  const toggleUserDropdown = () => setUserDropdown(!userDropdown);
  const toggleProductDropdown = () => setProductDropdown(!productDropdown);
  const toggleEmployeeDropdown = () => setEmployeeDropdown(!employeeDropdown);
  const togglePurchaseDropdown = () => setPurchaseDropdown(!purchaseDropdown);
  const toggleSellDropdown = () => setSellDropdown(!sellDropdown);
  const toggleReportDropdown = () => setReportDropdown(!reportDropdown);

  const raw = localStorage.getItem("empRole");

  const userMenus = raw && raw !== "undefined" ? JSON.parse(raw) : null;

  const [allowedMenus, setAllowedMenus] = useState(userMenus ? userMenus.menus : []);
  const [allowedSubMenus, setAllowedSubMenus] = useState([]);

  useEffect(() => {
    if (!Array.isArray(allowedMenus)) return;

    const subMenus = allowedMenus.flatMap((menu) =>
      Array.isArray(menu.subMenus) ? menu.subMenus : []
    );
    console.log("all sub menus", subMenus);

    setAllowedSubMenus(subMenus);
  }, [allowedMenus]);

  useEffect(() => {
    const updatedRole = roleFromRedux || localStorage.getItem("role");
    setRole(updatedRole);
    console.log("roleUser:", roleUser);
  }, [roleFromRedux]);

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleDropdown = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const findMenu = (id) => {
    if (allowedMenus.length === 0) {
      return true;
    }

    if (allowedMenus.find((item) => item.id === id)) {
      return true;
    } else {
      return false;
    }
  };

  const findSubMenu = (id) => {
    if (allowedMenus.length === 0) {
      return true;
    }

    if (allowedSubMenus.length > 0 && allowedSubMenus.find((item) => item.id === id)) {
      return true;
    } else {
      return false;
    }
  };

  const canSeeItem = (item) =>
    item.orMenu ? findSubMenu(item.sub) || findMenu(item.orMenu) : findSubMenu(item.sub);

  return (
    <div>
      <div id="left-sidebar" className="sidebar rs-sidebar">
        {/* Brand */}
        <Link to="/" className="rs-brand">
          <span className="rs-brand-logo">
            <img src="/assets/images/RNDSAN.jpeg" alt="Logo" />
          </span>
        </Link>

        {/* Tabs */}
        <ul className="nav nav-tabs rs-tabs">
          <li className="nav-item">
            <a className="nav-link active1" data-toggle="tab" >
              RNDSAN Admin
            </a>
          </li>
         
        </ul>

        <div className="tab-content rs-tab-content">
          <div className="tab-pane fade show active" id="menu-uni" role="tabpanel">
            <nav className="sidebar-nav rs-nav">
              <ul className="metismenu rs-dashboard-list">
                <li className="active">
                  <Link to="/" className="dropdown-item rs-dashboard">
                    <span className="rs-icon-chip">
                      <i className="fa fa-dashboard" />
                    </span>
                    <span>Dashboard</span>
                  </Link>
                </li>

                <div>
                  <div className="dropdown">
                    <ul className="side-nav rs-menu">
                      {MENUS.map((menu) => {
                        const isOpen = activeIndex === menu.idx;
                        return (
                          <li
                            className={`side-nav-item rs-item ${isOpen ? "is-open" : ""}`}
                            key={menu.idx}
                          >
                            {findMenu(menu.id) && (
                              <a
                                href="#"
                                className="side-nav-link rs-parent"
                                onClick={() => toggleDropdown(menu.idx)}
                                aria-expanded={isOpen}
                                style={{ fontWeight: "700", textDecoration: "none" }}
                              >
                                <span className="rs-icon-chip">
                                  <i className={`fa ${menu.icon}`} />
                                </span>
                                <span className="rs-parent-label">{menu.label}</span>
                                <i className="fa fa-chevron-down rs-chevron" />
                              </a>
                            )}

                            {isOpen && (
                              <div className="side-nav-second-level rs-sub">
                                <ul>
                                  {menu.items.map(
                                    (item) =>
                                      canSeeItem(item) && (
                                        <li key={item.to}>
                                          <Link to={item.to} className="dropdown-item rs-sub-link">
                                            <i className={`fa ${item.icon} rs-sub-icon`} />
                                            <span>{item.label}</span>
                                          </Link>
                                        </li>
                                      )
                                  )}
                                </ul>
                              </div>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
